<template lang="pug">
  router-view
</template>

<script>
export default {
  created() {
    // Загружаем необходимые данные
    this.$store.dispatch('loadTestSession');
  },
};
</script>
